// removed by extract-text-webpack-plugin
module.exports = {"homeWrapNew":"qempo_Home_homeWrapNew-2SD4_mY","home":"qempo_Home_home-vNv9uSK","imageWrap":"qempo_Home_imageWrap-3EUMr8C","mobile":"qempo_Home_mobile-YL8OVQB","default":"qempo_Home_default-1J-mjIz","covid19":"qempo_Home_covid19-37UaVuv","modalButton":"qempo_Home_modalButton-NdXL9V0"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/components/Home.scss
// module id = 2282
// module chunks = 0